import Header from "containers/header/header";
import Sidebar from "containers/sidebar/sidebar";
import { Outlet } from "react-router-dom";
import Dialog from 'components/dialog/dialog'
import { useEffect } from "react";
import MessageBanner from "containers/messages/banner/banner";
function MainLayout() {

  //  轮播图暂时不部署
  // useEffect(() => {
  //   (document.getElementById('my_modal_3') as HTMLDialogElement).showModal()
  // }, []);

  return (
    <div>
      <MessageBanner />
      <Header />
      <div className="flex" id="main-content">
        {/* 轮播图暂时不部署 */}
        {/* <Dialog /> */}
        <Sidebar />
        <Outlet />
      </div>
    </div>
  );
}

export default MainLayout;
